import { isPlatformBrowser, Location } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { AuthenticationHelperService } from 'src/app/services/helpers/authentication-helper.service';
import { ItemsHelperService } from 'src/app/services/helpers/items-helper.service';
import { SearchHelperService } from 'src/app/services/helpers/search-helper.service';
import { NearYouHttpService } from 'src/app/services/http-services/near-you/near-you-http.service';
declare var google: any;

@Component({
  selector: 'app-near-you',
  templateUrl: './near-you.component.html',
})
export class NearYouComponent implements OnInit, AfterViewInit {
  tabSelected = 'near-me';
  subcategories: any[] = [];
  mapData: any;
  urlParams = { latitude: 0, longitude: 0, radius: 15, following: false, subcategoryId: 0, search_keyword: '' };
  @ViewChild('mapContainer', { static: false }) mapContainer!: ElementRef;
  map: any;
  marker: any;
  loggedUser: any;
  zoom = 12;
  selectedMarker: any;
  isMapLegendModalShow = true;
  isLatestAroundYouModalOpen = false;
  isSingleItemModal = false;
  groupsRaw: any[] = [];
  private markers: any[] = [];
  areItemsSelected = false;
  itemsInAroundYou: any[] = [];
  currentLocation: any;

  constructor(
    private itemsHelperService: ItemsHelperService,
    private nearYouHttp: NearYouHttpService,
    private searchHelperService: SearchHelperService,
    private authHelperService: AuthenticationHelperService,
    private location: Location,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.itemsHelperService.selectedTheme$.subscribe((themeId) => {
        this.urlParams.subcategoryId = themeId;
        this.getNearYouMapData();
      });
    }
    if (isPlatformBrowser(this.platformId)) {
      this.itemsHelperService.selectedFollowingType$.subscribe((type) => {
        this.urlParams.following = type;
        this.getNearYouMapData();
      });
    }
  }

  ngOnInit(): void {
    this.loggedUser = this.authHelperService.getUserData;
    if (isPlatformBrowser(this.platformId)) {
      this.isMapLegendModalShow = localStorage.getItem('isMapLegendSetToTrue') === 'true' ? false : true;
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.requestLocation();
    }
  }

  loadMap(data: any[], groupsRaw: any[]): void {
    if (isPlatformBrowser(this.platformId)) {
      if (!this.map) {
        const mapOptions: google.maps.MapOptions = {
          center: { lat: this.urlParams.latitude, lng: this.urlParams.longitude },
          zoom: this.zoom,
          disableDefaultUI: true,
          styles: this.itemsHelperService.mapsStyles
        };
        this.map = new google.maps.Map(this.mapContainer?.nativeElement, mapOptions);
        this.map.addListener('dragend', () => {
          const newCenter = this.map?.getCenter();
          if (newCenter) {
            this.urlParams.latitude = newCenter.lat();
            this.urlParams.longitude = newCenter.lng();
          }
          this.getNearYouMapData();
        });
      } else {
        this.map.setCenter(new google.maps.LatLng(this.urlParams.latitude, this.urlParams.longitude));
      }

      this.markers.forEach(marker => marker.setMap(null));
      this.markers = [];
      data.forEach((locationData) => {
        this.addCustomMarker({ lat: locationData.coordinate.lat, lng: locationData.coordinate.lng }, locationData, groupsRaw);
      });
      this.addCurrentLocationMarker();
    }
  }

  addCustomMarker(position: google.maps.LatLngLiteral, locationData: any, groupsRaw: any[]): void {
    if (isPlatformBrowser(this.platformId)) {
      const itemsPin = document.createElement('div');
      const itemPins = {
        typeA: () => `
             <div class="wrapper-pin-items">
          <div class="wrapper-images-item">
             <img class="image-item-1" src="${locationData.items[0] && locationData.items[0]?.lyst_item_image_url !== null ? locationData.items[0].lyst_item_image_url : 'assets/images/no-image.png'}" alt="">
             <img class="image-item-2" src="${locationData.items[1] && locationData.items[1]?.lyst_item_image_url !== null ? locationData.items[1].lyst_item_image_url : 'assets/images/no-image.png'}" alt="">
             <img class="image-item-3" src="${locationData.items[2] && locationData.items[2]?.lyst_item_image_url !== null ? locationData.items[2].lyst_item_image_url : 'assets/images/no-image.png'}" alt="">
          </div>
         <div class="arrow-pin"></div>
         <span class="number-items">${locationData.items.length}</span>
      </div>\`
        `,

        typeB: () => `
          <div class="wrapper-pin-item ${locationData.items[0].lyst.user_id === this.loggedUser.id ? 'my-item' : ''}">
          <img class="image-item" src="${locationData.items[0].lyst_item_image_url !== null ? locationData.items[0].lyst_item_image_url : 'assets/images/no-image.png'}" alt="">
          <img class="image-star" src="../../../../../assets/icons/rating/icon-star-fill.svg" alt="">
          <span>${locationData.items[0].average_rating}</span>
          <div class="arrow-pin"></div>
        </div>
        `
      };
      itemsPin.innerHTML = locationData.is_single_item_group ? itemPins.typeB() : itemPins.typeA();
      if (isPlatformBrowser(this.platformId)) {
        import('src/app/CustomMarker').then(({ CustomMarker }) => {
          // Now you can safely use CustomMarker
          const customMarker = new CustomMarker(
            new google.maps.LatLng(position.lat, position.lng),
            itemsPin,
            () => this.handleMarkerClick(locationData, groupsRaw),
            this.platformId
          );
          customMarker.setMap(this.map);
          this.markers.push(customMarker);
        }).catch(() => {
        });
      }
    }
  }

  handleMarkerClick(locationData: any, groupsRaw: any[]): void {
    if (isPlatformBrowser(this.platformId)) {
      this.areItemsSelected = false;
      this.isSingleItemModal = false;
      const matchingItem = groupsRaw.find((item: any) => {
        return item.average_location.latitude === locationData.coordinate.lat && item.average_location.longitude === locationData.coordinate.lng;
      });

      if (matchingItem) {
        this.selectedMarker = matchingItem;
        this.itemsInAroundYou = matchingItem.is_single_item_group ? this.groupsRaw : matchingItem.items;
        matchingItem.is_single_item_group ? this.isSingleItemModal = true : this.areItemsSelected = true;
        this.cdr.detectChanges();
      }
    }
  }

  selectTab(selected: string): void {
    this.tabSelected = selected;
  }

  async getNearYouMapData(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      this.nearYouHttp.getNearYouMapData(this.urlParams).then(async res => {
        try {
          this.mapData = res.data;
          this.groupsRaw = res.groupsRaw;
          this.itemsInAroundYou = res.groupsRaw;
          this.subcategories = res.subcategories;
        } catch (error) {
        } finally {
          this.loadMap(res?.groups || [], res.groupsRaw);
        }
      });
    }
  }

  requestLocation(): void {
    this.searchHelperService.getLatAndLong().then((response: GeolocationPosition) => {
      this.urlParams.latitude = response.coords.latitude;
      this.urlParams.longitude = response.coords.longitude;
      this.currentLocation = response.coords;
      this.getNearYouMapData();
    }).catch((error) => {
      alert(error);
    });
  }

  goBack(): void {
    if (this.isSingleItemModal || this.areItemsSelected) {
      this.isSingleItemModal = false;
      this.areItemsSelected = false;
      this.itemsInAroundYou = this.groupsRaw;
    } else {
      this.location.back();
    }
  }

  openGoogleMaps(): void {
    const lat = this.selectedMarker.is_single_item_group ? this.selectedMarker.average_location.latitude : this.selectedMarker.latitude;
    const lng = this.selectedMarker.is_single_item_group ? this.selectedMarker.average_location.longitude : this.selectedMarker.longitude;
    this.nearYouHttp.openGoogleMaps(this.urlParams.latitude, this.urlParams.longitude, lat, lng)
  }

  async setMarkerAndModal(item: any): Promise<void> {
    this.isSingleItemModal = true;
    this.isLatestAroundYouModalOpen = false;
    this.selectedMarker = item;
    const lat = !this.selectedMarker.is_single_item_group ? Number(this.selectedMarker.latitude) : this.selectedMarker?.average_location?.latitude;
    const lng = !this.selectedMarker.is_single_item_group ? Number(this.selectedMarker.longitude) : this.selectedMarker?.average_location?.longitude;
    this.map.setCenter({ lat, lng });
    this.map.setZoom(10);
  }

  addCurrentLocationMarker(): void {
    if (this.map) {
      const currentLocationMarkerContent = document.createElement('div');
      currentLocationMarkerContent.innerHTML = `
        <div class="current-location-marker">
          <div class="pulse"></div>
          <div class="marker-center"></div>
        </div>
      `;

      if (isPlatformBrowser(this.platformId)) {
        import('src/app/CustomMarker').then(({ CustomMarker }) => {
          const customMarker = new CustomMarker(
            new google.maps.LatLng(this.currentLocation.latitude, this.currentLocation.longitude),
            currentLocationMarkerContent,
            null,
            this.platformId
          );
          customMarker.setMap(this.map);
        }).catch(() => {
        });
      }
    }
  }

}
